export default __webpack_public_path__ + "static/instagramLogo-45b06f8fd98d66c7c3d91edce057784f.svg";